import {DpReferencePriceSettingsRestDto} from "@/api/pharma-cpc-mgmt/models";
import {ReferencePricePresentationEnum} from "@/api/enums/reference-price-presentation-enum";

export class DpReferencePriceSettingsRestDtoModel implements DpReferencePriceSettingsRestDto {
    presentation_code: ReferencePricePresentationEnum;
    global_correction_value: number;
    is_opt_out_for_price_sharing: boolean;

    constructor(
        presentation_code: ReferencePricePresentationEnum,
        global_correction_value: number,
        is_opt_out_for_price_sharing: boolean
    ) {
        this.presentation_code = presentation_code;
        this.global_correction_value = global_correction_value;
        this.is_opt_out_for_price_sharing = is_opt_out_for_price_sharing;
    }

    public static createWithDefaults(): DpReferencePriceSettingsRestDtoModel {
        return new this(ReferencePricePresentationEnum.SHOW_NOTIFICATION_AND_REF_PRICE, 0, false);
    }
}
